import React from 'react';
import { Box, Alert, AlertTitle, Typography, LinearProgress } from '@mui/material';

export default function RestoreProgressPanel({ status }) {
  if (!status || (!status.in_progress && (!status.job || status.job.status === 'done' && _olderThan(status.job, 60*1000)))) {
    if (!status?.job) return null;
  }
  if (!status.job) return null;

  const { job, in_progress } = status;

  if (in_progress) {
    return (
      <Box sx={{ my: 2 }}>
        <Alert severity="info">
          <AlertTitle>Restoring {job.domain_name}…</AlertTitle>
          <Box sx={{ mt: 1, mb: 1 }}><LinearProgress /></Box>
          <Typography variant="body2" component="pre" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: 12 }}>
            {job.result_log || '(no progress yet)'}
          </Typography>
        </Alert>
      </Box>
    );
  }

  if (job.status === 'done') {
    return (
      <Alert severity="success" sx={{ my: 2 }}>
        <AlertTitle>Restore complete</AlertTitle>
        {job.result_log || ''}
      </Alert>
    );
  }
  if (job.status === 'failed') {
    return (
      <Alert severity="error" sx={{ my: 2 }}>
        <AlertTitle>Restore failed</AlertTitle>
        <Typography variant="body2" component="pre" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: 12 }}>
          {job.result_log || ''}
        </Typography>
      </Alert>
    );
  }
  return null;
}

function _olderThan(job, ms) {
  if (!job.completed_at) return false;
  return (Date.now() - new Date(job.completed_at).getTime()) > ms;
}
